module.exports = __webpack_public_path__ + "img/close-outline.ec6d5934.svg";